<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';

// Props
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
});

// Watch for changes to modelValue (modal visibility)
watch(
    () => props.modelValue,
    (newValue) => {
        // When modal is opened or closed, reset search state
        if (!newValue || newValue) {
            showSearch.value = false;
            searchQuery.value = '';
        }
    }
);

// Emits
const emit = defineEmits(['update:modelValue', 'navigate']);

// Search state
const showSearch = ref(false);
const searchQuery = ref('');

// App data
const recentApps = ref([
    { id: 1, name: 'Odyssey', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Grad%20unions%20desktop-0eLs1BLBEVzhfA2BhHAHEqJnvUFBHU.svg', route: 'home' },
    { id: 2, name: 'PI Dashboard', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/PI%20Dash%20desktop-swGbyNTTMBao7WEFlN55NyLavI7UAI.svg', route: 'pi-dashboard' }
]);

const allApps = ref([
    { id: 1, name: 'Parking', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Parking%20desktop-lWlOBAKd1iyRxJnRg8sSYqTtvlV2DU.svg' },
    { id: 2, name: 'Spaces', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Spaces%20desktop-5TusT4FIu0G12bp0ZKEXQzxAahUV4n.svg', route: 'spaces' },
    { id: 3, name: 'MIT ID', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/MIT%20ID%20desktop-dy2fkC7A9g5vzkLefWr3keTykDXfwm.svg' },
    { id: 4, name: 'My Access', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/My%20access%20desktop-30mXtYbn2hqnq5bJSkgYql2k4ZTS2r.svg' },
    { id: 5, name: 'Visitors', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Visitors%20desktop-j4TxH3h94dEoWHWNawvcgJylLWGCEZ.svg' },
    { id: 6, name: 'Travel', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Travel%20desktop-rmxzo4Hizf8ObEPUaZZEL9Rt93wRGI.svg' },
    { id: 7, name: 'Reimbursement', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/RFP%20desktop-dsFQLfdV4m8hkiKFCQn6jNR2t25E70.svg' },
    { id: 8, name: 'Time Portal', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Time%20portal%20desktop-NkI4iMYXxVq5q1jSMfrXayXBufeiQy.svg' },
    { id: 9, name: 'Odyssey', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Grad%20unions%20desktop-0eLs1BLBEVzhfA2BhHAHEqJnvUFBHU.svg', route: 'home' },
    { id: 10, name: 'Onboarding', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Onboarding%20desktop-q5BJK3NCDvQfhIIfJYd39bAds5uDxp.svg' },
    { id: 11, name: 'Open Enrollment', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/OE%20desktop-RxOJPjVKC7SZEnpdwkhDeNTxY384AB.svg' },
    { id: 12, name: 'OE Admin', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/OE%20desktop-RxOJPjVKC7SZEnpdwkhDeNTxY384AB.svg' },
    { id: 13, name: 'Commencement', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Commencement%20desktop-LsQhxniRjjTI6ULNVMcktrlRCeG7wM.svg' },
    { id: 14, name: 'Diploma Pickup', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Diploma%20pickup%20desktop-ECI40OG6EzFYt1lw5nCv4bowdpuQ9E.svg' },
    { id: 15, name: 'LWLC Admin', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/LWLC%20desktop-BuBUcJjop6Rb6n9L8lwrtOhDu9sYPN.svg' },
    { id: 16, name: 'LWLC', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/LWLC%20mobile-SXVRR0SsVDjmQZyPJWQJzblpWlAiJ7.svg' },
    { id: 17, name: 'Analytics', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/PI%20Dash%20desktop-swGbyNTTMBao7WEFlN55NyLavI7UAI.svg' },
    { id: 18, name: 'PI Dashboard', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/PI%20Dash%20desktop-swGbyNTTMBao7WEFlN55NyLavI7UAI.svg', route: 'pi-dashboard' },
    { id: 19, name: 'Settings', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/TLO%20desktop-SMU4pNAG9TEOiIQkIKLMWYQFq3VXld.svg' },
    { id: 20, name: 'Under Recovery', icon: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Under%20recovery%20desktop-QoLXvsLRw8j5mJVVGvxwynNTFHjHVU.svg' }
]);

// Filtered apps based on search query
const filteredRecentApps = computed(() => {
    if (!searchQuery.value) return recentApps.value;
    return recentApps.value.filter((app) => app.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
});

const filteredAllApps = computed(() => {
    if (!searchQuery.value) return allApps.value;
    return allApps.value.filter((app) => app.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
});

// Functions
const toggleSearch = () => {
    showSearch.value = true;
};

const clearSearch = () => {
    searchQuery.value = '';
    showSearch.value = false;
};

const openApp = (app) => {
    // Close the app launcher
    emit('update:modelValue', false);

    // Navigate to the app route if it exists
    if (app.route) {
        emit('navigate', app.route);
    } else if (app.name === 'Spaces') {
        emit('navigate', 'spaces');
    } else if (app.name === 'PI Dashboard') {
        emit('navigate', 'pi-dashboard');
    }
};

// Add global style to hide scrollbars when component is mounted
const style = document.createElement('style');
onMounted(() => {
    style.textContent = `
    .p-dialog-content {
      -ms-overflow-style: none !important;
      scrollbar-width: none !important;
    }
    .p-dialog-content::-webkit-scrollbar {
      display: none !important;
    }
    .hide-scrollbar {
      -ms-overflow-style: none !important;
      scrollbar-width: none !important;
    }
    .hide-scrollbar::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .p-component-overlay {
      backdrop-filter: blur(10px) !important;
      -webkit-backdrop-filter: blur(10px) !important;
      background-color: rgba(0, 0, 0, 0.6) !important;
    }
  `;
    document.head.appendChild(style);
});
</script>

<template>
    <Dialog
        :visible="modelValue"
        @update:visible="$emit('update:modelValue', $event)"
        :dismissableMask="true"
        modal
        :style="{ width: '700px', height: '640px', borderRadius: '24px' }"
        :showHeader="false"
        :closable="false"
        class="app-launcher-dialog hide-scrollbar"
        :contentStyle="{ borderRadius: '24px', padding: '0', height: '100%' }"
        :pt="{
            root: { class: 'rounded-dialog hide-scrollbar' },
            content: { class: 'rounded-content hide-scrollbar p-0' }
        }"
        pt:mask:class="backdrop-blur-sm"
    >
        <div class="app-launcher-container">
            <!-- Sticky Header with back button and search -->
            <div class="sticky top-0 z-10 bg-white pl-3 pt-6 pr-6 pb-4 border-b border-gray-100">
                <div class="flex justify-between items-center">
                    <div class="flex items-center">
                        <button class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 text-black" @click="$emit('update:modelValue', false)">
                            <i class="pi pi-arrow-left"></i>
                        </button>
                        <h2 class="text-lg font-medium ml-2 text-black">My Apps</h2>
                    </div>
                    <div>
                        <button v-if="!showSearch" @click="toggleSearch" class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 text-black">
                            <i class="pi pi-search"></i>
                        </button>
                        <div v-else class="relative">
                            <span class="p-input-icon-left p-input-icon-right">
                                <i class="pi pi-search" />
                                <InputText v-model="searchQuery" placeholder="Search" class="w-64" />
                                <i class="pi pi-times cursor-pointer" @click="clearSearch" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Scrollable Content Area -->
            <div class="overflow-y-auto flex-1 px-6 pt-4 pb-6 hide-scrollbar">
                <!-- Recently used section -->
                <div class="mb-4">
                    <h3 class="text-base font-medium mb-3 text-black">Recently used</h3>
                    <div class="grid grid-cols-6 gap-3">
                        <div v-for="app in filteredRecentApps" :key="app.id" class="flex flex-col items-center cursor-pointer app-hover p-1 rounded-lg" @click="openApp(app)">
                            <div class="w-16 h-16 flex items-center justify-center mb-1">
                                <img :src="app.icon" :alt="app.name" class="w-16 h-16" />
                            </div>
                            <span class="text-xs text-center">{{ app.name }}</span>
                        </div>
                    </div>
                </div>

                <!-- Separator line -->
                <div class="border-t border-gray-200 my-4"></div>

                <!-- Your Apps section -->

                <div>
                    <h3 class="text-base font-medium mb-3 text-black">Your Apps</h3>

                    <!-- Show the grid only when there are apps -->
                    <div v-if="filteredAllApps.length > 0" class="grid grid-cols-6 gap-3">
                        <div v-for="app in filteredAllApps" :key="app.id" class="flex flex-col items-center cursor-pointer app-hover p-1 rounded-lg" @click="openApp(app)">
                            <div class="w-16 h-16 flex items-center justify-center mb-1">
                                <img :src="app.icon" :alt="app.name" class="w-16 h-16" />
                            </div>
                            <span class="text-xs text-center truncate w-full">{{ app.name ? app.name : 'App could not be found' }}</span>
                        </div>
                    </div>

                    <!-- Show this message when no apps are found -->
                    <div v-else class="flex flex-col items-center justify-center py-10">
                        <div class="text-gray-400 mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="8" y1="12" x2="16" y2="12"></line>
                            </svg>
                        </div>
                        <p class="text-gray-500 text-center">No apps found matching your search</p>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<style>
/* Global styles to hide scrollbars */
.hide-scrollbar {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
    overflow-y: auto;
}

.hide-scrollbar::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
}

/* Target PrimeVue specific scrollbar elements */
.p-dialog-content {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
}

.p-dialog-content::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
}

.p-component-overlay {
    backdrop-filter: blur(10px) !important;
    -webkit-backdrop-filter: blur(10px) !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
}

/* Ensure consistent blur across browsers */
@supports not (backdrop-filter: blur(10px)) {
    .p-component-overlay,
    .p-dialog-mask {
        background-color: rgba(0, 0, 0, 0.8) !important;
    }
}
</style>

<style scoped>
.app-launcher-dialog {
    border-radius: 24px;
}

.app-launcher-container {
    background-color: white;
    border-radius: 24px;
    width: 100%;
    height: 100%;
    max-height: 640px;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

:deep(.p-dialog) {
    border-radius: 24px !important;
    overflow: hidden;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

:deep(.p-dialog-mask) {
    backdrop-filter: blur(10px) !important;
    -webkit-backdrop-filter: blur(10px) !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
    z-index: 9999 !important;
}

:deep(.p-dialog-content) {
    padding: 0 !important;
    border-radius: 24px !important;
    max-height: 600px;
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
    display: flex;
    flex-direction: column;
}

:deep(.p-dialog-content::-webkit-scrollbar) {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
}

:deep(.rounded-dialog) {
    border-radius: 24px !important;
}

:deep(.rounded-content) {
    border-radius: 24px !important;
}

:deep(.p-dialog-wrapper) {
    border-radius: 24px !important;
}

:deep(.p-dialog-container) {
    border-radius: 24px !important;
}

:deep(.p-inputtext) {
    padding: 0.5rem 2.5rem;
    font-size: 0.875rem;
    border-radius: 8px;
}

:deep(.p-input-icon-left > i:first-of-type) {
    left: 0.75rem;
}

:deep(.p-input-icon-right > i:last-child) {
    right: 0.75rem;
}

/* Custom app hover effect with #2F5279 at 5% opacity */
.app-hover {
    transition: background-color 0.2s ease;
}

.app-hover:hover {
    background-color: rgba(47, 82, 121, 0.05);
}
</style>
